// @flow
import actionTypes from './actionTypes';
import type { TAction } from './index';
import { ConfigAggregators } from '../lib/Config/types';


type TNavigationItem = { id: string, path: string, state?: ?any };
export type TNavigationState = {
  current: TNavigationItem,
  history: Array<TNavigationItem>,
};

function getInitialState(): TNavigationState {
  const initial = {
    id: Math.random().toString(),
    path: '/intro',
    state: null,
  };

  return { current: initial, history: [] };
}

export default function reducer(state: TNavigationState = getInitialState(), action: TAction): TNavigationState {
  let current = { ...state.current };

  switch (action.type) {
    case actionTypes.FETCH_CONFIG: {
      if (action.payload.config) {
        switch (action.payload.config.aggregator) {
          case ConfigAggregators.Plaid: current.path = '/plaid'; break;
          // case ConfigAggregators.MX: current.path = '/mx'; break;
          default:
        }
      }

      return { ...state, current };
    }
    case actionTypes.NAVIGATE_TO: {
      const current = Object.assign(
        {},
        action.payload.navigation ? action.payload.navigation.current : state.current,
        { id: Math.random().toString() },
      );

      const history = [state.current].concat(state.history);
      return { current, history };
    }
    case actionTypes.NAVIGATE_BACK:
      return { ...state, current: state.history[0], history: state.history.slice(1) };
    default: return state;
  }
}
